import { toggleScrollLock } from 'common/utils';

const MODAL_CLASS = 'shop-now__modal';
const SCROLL_LOCK_SELECTOR = `.${MODAL_CLASS} .Modal__content`;

export function initializeShopNowModal() {
  const modalEl = document.getElementsByClassName(MODAL_CLASS)[0];
  const showModalEl = document.getElementsByClassName('js-show-shop-modal')[0];
  const closeModalEl = document.getElementsByClassName(
    'shop-now__close-circle'
  )[0];

  showModalEl &&
    showModalEl.addEventListener('click', () => {
      modalEl.classList.remove('hide');
      toggleScrollLock(SCROLL_LOCK_SELECTOR, true);
    });

  closeModalEl &&
    closeModalEl.addEventListener('click', () => {
      modalEl.classList.add('hide');
      toggleScrollLock(SCROLL_LOCK_SELECTOR, false);
    });
}
